import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import NotificationViewItemDetails from "./NotificationViewItemDetails"
import NotificationViewItemDates from "./NotificationViewItemDates"
import NotificationViewLinkDetails from "./NotificationViewLinkDetails"

const SourceViewItem = ({ model, isFetching }) => (
    <ItemDetailsColumns className="item-container">
        <ItemDetailsColumn>
            <NotificationViewItemDetails
                title={model.title}
                link={model.link}
                message={model.message}
                type={model.type}
                send_push={model.send_push}
                isFetching={isFetching}
            />
            <NotificationViewLinkDetails
                type={model.type}
                entity_id={model.entity_id}
                link={model.link}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <NotificationViewItemDates
                expires={model.expires}
                not_before={model.not_before}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default SourceViewItem
